module.exports = __webpack_public_path__ + "static/media/switch-button.31f5801a.png";